// extracted by mini-css-extract-plugin
export var messageSideLeft = "_om-1";
export var messageSideRight = "_om-2";
export var subscribeToBackInStockBubbleContainer = "_om-0";